import { render, staticRenderFns } from "./SubHeading.vue?vue&type=template&id=08f2a540&scoped=true&"
import script from "./SubHeading.vue?vue&type=script&lang=js&"
export * from "./SubHeading.vue?vue&type=script&lang=js&"
import style0 from "./SubHeading.vue?vue&type=style&index=0&id=08f2a540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2a540",
  null
  
)

export default component.exports